import React, { useEffect } from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useState } from "react";
import {
  VEHICLE_TYPE,
  PUT_VEHICLE_REPORT,
  VEHICLE_TYPE_INACTIVE,
  VEHICLE_TYPE_ACTIVE,
  UPLOAD_FILE,
  UPDATE_FILE,
} from "../../../services/apiUrls";
import { post, Put } from "../../../services/service";
import axios from "axios";
import { fetchVehicleTypes } from "../../../api/vehicleType";
import useIsEqual from "./useIsEqual";
import toast from "react-hot-toast";

export function useVehicleMaster() {
  const [vehicleData, setVehicleData] = useState([]);
  const [formValues, setFormValues] = useState({
    deleted: false,
    description: "",
    id: null,
    key: "",
    vehicletype: "",
    imageUrl: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const { isEqual, isSpace } = useIsEqual();
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchvalue] = useState("");
  const [buttonHandle, setButtonHandle] = useState("");

  let tenantId = localStorage.getItem("tenantId");
  let locationId = localStorage.getItem("locationId");

  const [files, setFiles] = useState({
    userImg: "",
    vehicleImage: "",
  });

  // Upload vehicleImage
  // const uploadVehicleImage = async (formData) => {
  //   formData.append("file", files.vehicleImage[0]);
  //   formData.append("userId", "09361006-6741-45e3-8ea0-acfb04efc97f");
  //   const response = await post(UPLOAD_FILE, formData);
  //   return response;
  // };

  const fileUpload = (file, mediaId) => {
    return new Promise(async (resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);
      try {
        let resp;
        if (mediaId) {
          formData.append("mediaUrl", mediaId);
          resp = await Put(UPDATE_FILE, formData);
        } else resp = await post(UPLOAD_FILE, formData);
        if (resp.mediaUrl) resolve(resp.mediaUrl);
        else reject("Media not uploaded");
      } catch (err) {
        reject(err);
      }
    });
  };

  const isDisabled =
    !formValues?.vehicletype ||
    !formValues?.description ||
    (!formValues?.imageUrl && !files.vehicleImage[0]);

  const getVehicleTypes = async () => {
    let response = await fetchVehicleTypes(tenantId, locationId);
    setVehicleData(response);
  };

  const handleChange = (event) => {
    setErrorMessage("");
    let convertedValue = isSpace(event.target.value);
    setFormValues({ ...formValues, [event.target.name]: convertedValue });
  };

  const handleClickOpen = () => {
    setFiles({ ...files, userImg: "", vehicleImage: "" });
    setOpen(true);
    setButtonHandle("Add");
    handleClear();
  };

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleSearchChange = (e) => {
    setSearchvalue(e.target.value);
  };

  const handleSave = async () => {
    try {
      const imageUrl = await fileUpload(files.vehicleImage[0]);

      if (imageUrl) {
        const url = `${VEHICLE_TYPE.replace("{tenantId}", tenantId).replace(
          "{locationId}",
          locationId
        )}`;

        const data = {
          name: formValues.vehicletype,
          description: formValues.description,
          tenantId: localStorage.getItem("tenantId"),
          locationId: localStorage.getItem("locationId"),
          imageUrl,
        };

        const resp = await post(url, data);

        if (resp && resp.id !== "") {
          getVehicleTypes();
          handleClear();
          toast.success(
            `Vehicle ${formValues.id ? "updated" : "added"} successfully`
          );
        }
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = (row) => {
    setFormValues({
      ...formValues,
      deleted: row?.deleted,
      description: row?.description,
      id: row?.id,
      key: row?.key,
      vehicletype: row?.vehicletype,
      imageUrl: row.imageUrl,
    });

    localStorage.setItem("description", row?.description);
    setOpen(true);
    setButtonHandle("Edit");
  };

  const handleSaveEdit = async () => {
    try {
      const url = `${PUT_VEHICLE_REPORT.replace("{tenantId}", tenantId).replace(
        "{locationId}",
        locationId
      )}`;

      const data = {
        id: formValues.key,
        name: formValues.vehicletype,
        description: formValues.description,
        tenantId: localStorage.getItem("tenantId"),
        locationId: localStorage.getItem("locationId"),
      };

      if (files.vehicleImage[0]) {
        const imageUrl = await fileUpload(
          files.vehicleImage[0],
          formValues.imageUrl
        );
        data.imageUrl = imageUrl;
      }

      const resp = await Put(url, data);
      if (resp && resp.id !== "") {
        getVehicleTypes();
        handleClear();
        toast.success(
          `Vehicle ${formValues.id ? "updated" : "added"} successfully`
        );
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formValues?.id) {
      handleSaveEdit();
    } else {
      handleSave();
    }
  };

  const handleClear = () => {
    setFormValues({
      deleted: false,
      description: "",
      key: "",
      vehicletype: "",
      imageUrl: "",
    });
    setFiles({ userImg: "", vehicleImage: "" });
  };

  const filteredRows =
    vehicleData?.length === undefined || vehicleData?.length === 0
      ? []
      : vehicleData.filter(
          (row) =>
            row.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            row.description.toLowerCase().includes(searchValue.toLowerCase())
        );

  const columns = [
    {
      field: "id",
      headerName: "NO",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "vehicletype",
      headerName: "VEHICLE TYPE",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "active",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <>
          {params?.row?.deleted === false ? (
            <Button
              variant="contained"
              size="small"
              color="success"
              sx={{ width: "2rem" }}
              onClick={() => {
                vehicleTypeInactive(params.row.key);
              }}
            >
              <Typography sx={{ fontSize: "10px" }}>Active</Typography>
            </Button>
          ) : (
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ width: "2rem" }}
              onClick={() => {
                vehicleTypeActive(params.row.key);
              }}
            >
              <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
            </Button>
          )}
        </>
      ),
    },
    {
      field: "action",
      headerName: "ACTION",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" justifyContent="center">
          <IconButton onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
        </Box>
      ),
    },
  ];

  const rows = filteredRows.map((rowData, index) => ({
    key: rowData.id,
    id: index + 1,
    vehicletype: rowData.name,
    description: rowData.description,
    deleted: rowData.deleted,
    imageUrl: rowData.imageUrl,
  }));

  // VEHICLE TYPE INACTIVE
  const vehicleTypeInactive = async (vehicleId) => {
    try {
      const resp = await axios
        .delete(
          VEHICLE_TYPE_INACTIVE.replace("{tenantId}", tenantId)
            .replace("{locationId}", locationId)
            .replace("{vehicleId}", vehicleId)
        )
        .then((res) => {
          getVehicleTypes();
          return res;
        });
      return resp;
    } catch (err) {
      return err;
    }
  };

  // VEHICLE TYPE ACTIVE
  const vehicleTypeActive = async (restoreId) => {
    try {
      const resp = await axios
        .delete(
          VEHICLE_TYPE_ACTIVE.replace("{tenantId}", tenantId)
            .replace("{locationId}", locationId)
            .replace("{restoreId}", restoreId)
        )
        .then((res) => {
          getVehicleTypes();
          return res;
        });
      return resp;
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getVehicleTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    open,
    rows,
    columns,
    isDisabled,
    formValues,
    searchValue,
    errorMessage,
    buttonHandle,
    handleSave,
    handleClose,
    handleClear,
    handleChange,
    handleSaveEdit,
    handleClickOpen,
    handleSearchChange,
    findDuplicateVehicleType: handleSubmit,
    files,
    setFiles,
    setFormValues,
  };
}
